import React, { useState } from 'react';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import { toast } from 'react-toastify';
import { FaSpinner, FaFilePdf } from 'react-icons/fa';
import InvoicePDF from './InvoicePDF';
import { getCompanyDetails, toInvoiceShape } from '../config/CompanyDetails';

const InvoicePDFButton = ({ invoice, job, subbie, onSuccess }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGeneratePDF = async () => {
    setIsGenerating(true);
    try {
      // Company details ALWAYS from the single source (settings).
      const companyDetails = toInvoiceShape(await getCompanyDetails());

      // Generate the PDF blob
      const blob = await pdf(
        <InvoicePDF 
          invoice={invoice} 
          job={job} 
          subbie={subbie} 
          companyDetails={companyDetails} 
        />
      ).toBlob();

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Invoice_${invoice.invoice_number}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast.success('📄 Invoice downloaded successfully!');
      
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button
      onClick={handleGeneratePDF}
      disabled={isGenerating}
      className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-xs transition-colors flex items-center gap-1 shadow-sm disabled:opacity-50"
      style={{
        border: 'none',
        cursor: 'pointer',
      }}
    >
      {isGenerating ? (
        <FaSpinner className="animate-spin" size={12} />
      ) : (
        <FaFilePdf size={12} />
      )}
      {isGenerating ? 'Generating...' : 'Download PDF'}
    </button>
  );
};

export default InvoicePDFButton;
